import React from 'react';
import { Button, SpaceBetween } from '@amzn/awsui-components-core';
import { UserType } from '@amzn/awscat-pattern-library-service-model';
import ContentEngagementButton from '../content-engagement/ContentEngagementButton';

interface Props {
  contentId: string;
  userType: UserType;
  onReportToAuthor?: () => void;
}

const PublicationFeedbackForm = ({ contentId, userType, onReportToAuthor }: Props) => {
  const svgPath = '/images/ic_contact_group.svg';

  if (userType !== UserType.AWS) return null;

  return (
    <SpaceBetween direction="horizontal" size="xs">
      <ContentEngagementButton
        buttonText="Share an engagement"
        buttonVariant={'normal'}
        contentId={contentId}
        iconUrl={svgPath}
      />
      {onReportToAuthor && (
        <Button variant="normal" iconName="notification" onClick={onReportToAuthor}>
          Provide feedback
        </Button>
      )}
    </SpaceBetween>
  );
};

export default PublicationFeedbackForm;
